import { Injectable, inject } from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpInterceptorFn} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {environment} from "../../../environments/environment";
import { SessionService } from '../../services/session/session.service';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionService = inject(SessionService);
  const sessionId = sessionService.getSessionId();

  let headers = req.headers;
  if (sessionId) {
    // headers = headers.set('x-session-id', sessionId);
    console.log('Using stored session ID:', sessionId);
  } else {
    console.log('No stored session ID - will receive new one from server');
  }

  const clonedRequest = req.clone({
    headers,
    withCredentials: false
  });

  return next(clonedRequest);
};

//
// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     // Clone the request to add the withCredentials option
//     const clonedRequest = req.clone({
//       withCredentials: true
//     });
//     console.log(123);
//
//     // Pass the cloned request instead of the original request
//     return next.handle(clonedRequest);
//   }
// }
// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     const token = localStorage.getItem('token');
//
//     let headers = request.headers;
//
//     if (token) {
//       headers = headers.set('x-auth-token', token);
//       // request = request.clone({
//       //   setHeaders: {
//       //     Authorization: `Bearer ${token}`
//       //   }
//       // });
//     }
//     const clonedRequest = request.clone({ headers });
//     return next.handle(clonedRequest);
//   }
// }
